export const PrivacyConsentEnum = Object.freeze({
    TECHNICAL: 'technical',
    MARKETING: 'marketing',
    PARTNERSHIPS: 'partnerships',
    STATISTICS: 'statistics',
    NOT: {
        TECHNICAL: '!technical',
        MARKETING: '!marketing',
        PARTNERSHIPS: '!partnerships',
        STATISTICS: '!statistics',
    },
});

export const siteConfig = {
    ca: {
        defaultLang: 'en_CA',
        cookiePageUrl: 'https://www.ionos.ca/cookies',
        privacyTermsUrl: 'https://www.ionos.ca/terms-gtc/terms-privacy'
    },
    cloud: {
        defaultLang: 'de_DE',
        cookiePageUrl: 'https://www.ionos.de/cookies',
        privacyTermsUrl: 'https://www.ionos.de/terms-gtc/terms-privacy'
    },
    de: {
        defaultLang: 'de_DE',
        cookiePageUrl: 'https://www.ionos.de/cookies',
        privacyTermsUrl: 'https://www.ionos.de/terms-gtc/terms-privacy'
    },
    at: {
        defaultLang: 'de_DE',
        cookiePageUrl: 'https://www.ionos.at/cookies',
        privacyTermsUrl: 'https://www.ionos.at/terms-gtc/terms-privacy'
    },
    es: {
        defaultLang: 'es_ES',
        cookiePageUrl: 'https://www.ionos.es/cookies',
        privacyTermsUrl: 'https://www.ionos.es/terms-gtc/terms-privacy'
    },
    fr: {
        defaultLang: 'fr_FR',
        cookiePageUrl: 'https://www.ionos.fr/info-cookies',
        privacyTermsUrl: 'https://www.ionos.fr/terms-gtc/terms-privacy'
    },
    it: {
        defaultLang: 'it_IT',
        cookiePageUrl: 'https://www.ionos.it/cookies',
        privacyTermsUrl: 'https://www.ionos.it/terms-gtc/terms-privacy'
    },
    mx: {
        defaultLang: 'es_MX',
        cookiePageUrl: 'https://www.ionos.mx/cookies',
        privacyTermsUrl: 'https://www.ionos.mx/terms-gtc/terms-privacy'
    },
    uk: {
        defaultLang: 'en_GB',
        cookiePageUrl: 'https://www.ionos.co.uk/cookies',
        privacyTermsUrl: 'https://www.ionos.co.uk/terms-gtc/terms-privacy'
    },
    com: {
        defaultLang: 'en_US',
        cookiePageUrl: 'https://www.ionos.com/cookies',
        privacyTermsUrl: 'https://www.ionos.com/terms-gtc/terms-privacy'
    }
  };

export const langConfig = {
    de_DE: {
        advancedPageFlow: true,
        alternativeDisplay: true,
        heading: "Cookie-Einstellungen",
        mainDescription: [
            "Wir setzen Cookies ein, um Ihnen die Nutzung unserer Websites und Angebote zu erleichtern und das Laden von Inhalten zu beschleunigen. Cookies tragen dazu bei, dass unser Support Sie besser unterstützen kann. Bestimmte Cookies können auch dazu dienen, Ihnen Angebote zu unterbreiten – dabei entscheiden Sie, welche Cookies Sie zulassen oder ablehnen. Ihre Entscheidung können Sie jederzeit <a href='[LINK_COOKIE_PAGE]'>hier</a> ändern. Weitere Infos finden Sie in unserer <a href='[LINK_COOKIE_PAGE]'>Richtlinie zur Verwendung von Cookies</a> und in unseren <a href='[LINK_PRIVACY_TERMS]'>Datenschutzhinweisen</a>."
        ],
        thirdCountryData: "Drittländer sind Länder außerhalb der Europäischen Union. Mit Ihrer Zustimmung werden Daten in die USA übertragen. Die USA ist ein Drittland mit unzureichendem Datenschutzniveau. Dort besteht das Risiko, dass Behörden auf die Daten zugreifen, ohne dass ein richterlicher Beschluss vorliegt.",
        step1Description: [
          [
            "Wir setzen Cookies ein, um unsere Webseiten optimal für Sie zu gestalten, unsere Produkte für Sie zu verbessern sowie Ihnen zusammen mit Drittanbietern interessengerechte Werbung anzuzeigen. In den ",
            "CONFIG_BUTTON",
            " können Sie auswählen, welche Cookies Sie zulassen wollen, sowie Ihre Auswahl jederzeit ändern. Weitere Infos finden Sie in unserer ",
            "LINK_COOKIE_PAGE",
            " und in unseren ",
            "LINK_PRIVACY_TERMS",
            ". Technisch notwendige Cookies werden auch bei der Auswahl von ",
            "REJECT_BUTTON",
            " gesetzt."
          ],
          [
            "Mit einem Klick auf \"",
            "SELECTALL_BUTTON",
            "\" stimmen Sie der Verarbeitung und der Übermittlung Ihrer Daten an Drittländer zu.","TOOLTIP"
          ]
        ],
      step2Description: [
          [
            "Wir setzen Cookies ein, um unsere Webseiten optimal für Sie zu gestalten, unsere Produkte für Sie zu verbessern sowie Ihnen zusammen mit Drittanbietern interessengerechte Werbung anzuzeigen. Hier können Sie auswählen, welche Cookies Sie zulassen wollen, sowie Ihre Auswahl jederzeit ändern. Weitere Infos finden Sie in unserer ",
            "LINK_COOKIE_PAGE",
            " und in unseren ",
            "LINK_PRIVACY_TERMS",
            ". Technisch notwendige Cookies werden auch bei der Auswahl von ",
            "REJECT_BUTTON",
            " gesetzt."
          ],
          [
            "Mit einem Klick auf \"",
            "SELECTALL_BUTTON",
            "\" stimmen Sie der Verarbeitung und der Übermittlung Ihrer Daten an Drittländer zu.","TOOLTIP"
          ]
        ],
        configButton: "Einstellungen",
        rejectButton: "ablehnen",
        privacyTermsLink: "Datenschutzhinweisen",
        cookiePageLink: "Richtlinie zur Verwendung von Cookies",
        toggleLabel: "Details",
        mainCategories: [
            {
                key: PrivacyConsentEnum.TECHNICAL,
                disabled: true,
                preSelected: true,
                label: "Notwendig",
                details: [
                    {
                        type: "text",
                        value: [
                            "Technisch erforderliche Cookies ermöglichen die Navigation auf unseren Websites. Sie sorgen dafür, dass Sie unsere Websites ansehen und in unseren Angeboten navigieren können, von der Ansicht über die Auswahl bis zum Warenkorb. Grundfunktionen, wie die Darstellung und Auswahl von Produkten auf unseren Websites, das Befüllen des Warenkorbs oder der Login sind ohne sie nicht möglich.",
                        ],
                    },
                    {
                        type: "cookietable",
                        value: [
                            ["Firma","Zweck"],
                            [
                                ["Aklamio","Ermöglicht die Zuordnung der Provision bei einem Aufruf der Website über einen 'Kunden werben Kunden' Empfehlungs-Link."],
                                ["cm4all","Enthält die Session ID für den Website Designservice. Wird erst gesetzt wenn der Designservice genutzt wird."],
                                ["Threatmetrix","Wird zur Fraud Erkennung genutzt."],
                                ["uberall","Von List Local verwendet zur Authentifizierung des Nutzers. Wird erst gesetzt wenn List Local genutzt wird."]
                            ]
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.STATISTICS,
                preSelected: false,
                label: "Statistik",
                details: [
                    {
                        type: "text",
                        value: [
                            "Wir setzen Cookies zu statistischen Zwecken ein, um Ihr Nutzerverhalten besser zu verstehen und Sie bei Ihrer Navigation auf unseren Angebotsseiten zu unterstützen. Damit ist es uns zudem möglich, Ihre Navigation auf unseren Angebotsseiten zu erfassen und für die bedarfsgerechte Gestaltung unserer Services zu nutzen.",
                        ],
                    },
                    {
                        type: "cookietable",
                        value: [
                            ["Firma","Zweck"],
                            [
                                ["Adobe","Statistische Analyse der Nutzung unserer Webseite"],
                                ["1&1 Mail & Media","Wird für Profilbildung und statistische Auswertung genutzt."]
                            ]
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.MARKETING,
                label: "Marketing",
                details: [
                    {
                        type: "text",
                        value: [
                            "Wir speichern Informationen zu Ihrem Nutzerverhalten auf unserer Internetseite und verwenden diese Daten für individuelle Angebote und Kampagnen im Rahmen des Direktmarketings und für mehr Komfort im Rahmen der Nutzung unserer Webseite. Diese Cookies dienen z. B. dazu Ihnen spezielle Angebote auf der Website selbst oder in Mailings zu präsentieren. Zudem soll Ihnen das Surfen auf unsere Seite so attraktiv wie möglich gestaltet werden. Die hierfür gesetzten Cookies beschleunigen das Laden und Navigieren, da diese Websiteinhalte sichern, damit diese nicht bei jedem neuen Aufrufen neu geladen werden müssen. Die Verantwortung und Kontrolle für die Datenverarbeitung liegt bei uns. ",
                        ],
                    },
                    {
                        type: "cookietable",
                        value: [
                            ["Firma","Zweck"],
                            [
                                ["Beamer","Wird von List Local zur Anzeige von produktspezifischer Hilfe und Tipps genutzt."],
                                ["Salesforce","Pardot Session Cookie, um eine eindeutige Besucher-Id und eine eindeutige Kennung des Kontos zu speichern."],
                                ["Adobe","Statistische Analyse der Nutzung unserer Webseite"],
                                ["Mouseflow","Statistische Analyse der Nutzung unserer Webseite"],
                                ["Vimeo","Sammelt Daten von Nutzern zu ihrem Besuch und der abgerufenen Seiten. Wird für die Einbindung des Vimeo Videoplayer benötigt."],
                                ["1&1 Mail & Media","Wird für Profilbildung und statistische Auswertung genutzt."]
                            ]
                        ],
                    },
                ],
            },
            {
                key: PrivacyConsentEnum.PARTNERSHIPS,
                label: "Partnerschaften",
                details: [
                    {
                        type: "text",
                        value: [
                            "Auf unserer Seite werden Dienste von Drittanbietern eingebunden. Dabei werden beim Besuch von unserer Seite Daten mittels Cookies oder ähnlicher Technologien erfasst und an Dritte übermittelt, welche ihre Dienste eigenverantwortlich erbringen. Teilweise nutzt IONOS diese Daten für eigene Zwecke, insbesondere, um Ihnen auch außerhalb unserer Webseite individuelle Produkt- und Serviceangebote anzeigen zu können. Zudem können die Daten von den Drittanbietern ausgelesen und ausgewertet werden um Ihnen z.B. personalisierte Inhalte anzuzeigen. Die Verantwortung über unsere Verarbeitung hinausgehende Verwendung Ihrer Daten liegt bei den Drittanbietern. In welchem Umfang, zu welchen Zwecken und auf Basis welcher Rechtsgrundlage eine Weiterverarbeitung zu eigenen Zwecken des Drittanbieters erfolgt, entnehmen Sie bitte den Datenschutzhinweisen des Drittanbieters, welche Sie in unserer Richtlinie zur Verwendung von Cookies finden.",
                        ],
                    },
                    {
                        type: "cookietable",
                        value: [
                            ["Firma","Zweck"],
                            [
                                ["HubSpot","Beim Besuch einer passwortgeschützten Seite wird dieser Cookie gesetzt, damit bei künftigen Besuchen der Seite mit demselben Browser keine Anmeldung mehr erforderlich ist. Der Cookie-Name ist für jede passwortgeschützte Seite eindeutig."],
                                ["Cloudflare","Dieser Cookie wird durch Cloudflare, den CDN-Anbieter von HubSpot, festgelegt. Es hilft Cloudflare, böswillige Besucher zu identifizieren und das Blockieren von legitimen Benutzern zu minimieren."],
                                ["Facebook","Ausspielung von individualisierter Werbung auf Webseiten im Internet"],
                                ["Google","Ausspielung von individualisierter Werbung auf Webseiten im Internet"],
                                ["Outbrain","Von Outbrain genutzter Tracking-Cookie, der von uns für die zielgerichtete Werbung eingesetzt wird."],
                                ["Taboola","Wird auf Websites unserer Publisher-Kunden verwendet, die die Taboola Newsroom-Dienste nutzen. Dieses Cookie wird verwendet, um die verweisende Website zu identifizieren (d.h. die Website, die der Benutzer besucht hat, bevor er auf die Website dieses Herausgebers gelangt ist)."],
                                ["TikTok","Ausspielung von individualisierter Werbung auf Webseiten im Internet"],
                                ["Yahoo","Von Yahoo genutzter Tracking-Cookie, der von uns für die zielgerichtete Werbung eingesetzt wird."],
                                ["LinkedIn","Von LinkedIn genutzter Tracking-Cookie, der von uns für die zielgerichtete Werbung eingesetzt wird."],
                                ["TUNE Inc.","Dies ist ein angebotsspezifischer Cookie. Er ist für die die Klickdauer des Angebots gültig und enthält die Transaktions-ID und die IP-Adresse des Benutzers, um Conversions zu verfolgen. Das * steht für die Angebots-ID. Für jedes angeklickte Angebot gibt es eine andere Version dieses Cookies."],
                                ["FullStory Inc.","Wird von rankingCoach verwendet für Nutzungsstatistiken zur Produktverbesserung."],
                                ["Bing","Ausspielung von individualisierter Werbung auf Webseiten im Internet"],
                                ["Twitter","Von Twitter genutzter Tracking-Cookie, der von uns für die zielgerichtete Werbung eingesetzt wird."],
                                ["RTB House","Von RTB House genutzter Tracking-Cookie, der zur Ausspielung und Messung dynamischer Werbung eingesetzt wird."],
                                ["Spotify","Dient der Messung der Performance von Werbekampagnen auf Spotify sowie der Personalisierung der Nutzererfahrung."],
                                ["Dealfront","Zur Erfassung der IP-Adressen von Unternehmen."]
                            ]
                        ],
                    },
                ],
            },
        ],
        confirmSelection: "Auswahl bestätigen",
        confirmFunctional: "Ablehnen",
        selectAllDefault: "Akzeptieren",
        selectAllSelection: "Alle akzeptieren",
        selectAll: "Akzeptieren",
        goBack: "zurück",
        imprint: {
            label: "Impressum",
            href: "https://www.ionos.de/impressum",
        }
    },
    en_US: {
        advancedPageFlow: false,
        heading: "Cookies and your options",
        mainDescription: [
            "We use cookies in order to provide you with the best possible user experience on our website and to provide you with relevant, targeted offers. Click on Accept all to consent to the use of all cookies. You can also choose which cookies you'll allow by checking the boxes below and clicking on Submit preferences to confirm your choices. You can change your preferences at any time in your settings <a href='[LINK_COOKIE_PAGE]'>here</a>. More information on our use of cookies can be found in our <a href='[LINK_COOKIE_PAGE]'>Guidelines for the Use of Cookies</a> and our <a href='[LINK_PRIVACY_TERMS]'>Privacy Policy.</a>"
        ],
        toggleLabel: "details",
        mainCategories: [
            {
                key: PrivacyConsentEnum.TECHNICAL,
                disabled: true,
                preSelected: true,
                label: "Required cookies",
                details: [
                    {
                        type: "text",
                        value: [
                            "These cookies are required in order to view and navigate our website, from selecting and adding a product to your shopping cart, through to the purchasing phase. Please note that basic functions like the display and selection of products, adding items to your cart and signing into your account cannot be processed without them."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.STATISTICS,
                preSelected: false,
                label: "Analytics",
                details: [
                    {
                        type: "text",
                        value: [
                            "We use cookies for analytical purposes in order to better understand user behavior and to support you in navigating throughout our product pages. This also allows us to track your movements to help us redesign and optimize our website to match demands."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.MARKETING,
                label: "Marketing",
                details: [
                    {
                        type: "text",
                        value: [
                            "We store information on your user behavior on our website in order to provide customized offers and campaigns on, for example, the website itself or in follow-up marketing emails. These cookies also enhance your user experience on our website by reducing load times, and saving website content so that it does not have to be reloaded each time you visit. We are fully responsible for the processing and controlling of any data collected."
                        ],
                    },
                ],
            },
            {
                key: PrivacyConsentEnum.PARTNERSHIPS,
                label: "Partners",
                details: [
                    {
                        type: "text",
                        value: [
                            "Our website relies on third-party services. When you visit, data is collected using cookies or similar technologies and transmitted to third parties we partner with. In some cases, we use this data for our own purposes, such as customizing products and offers to better suit your needs. In addition, the data may be read and used by third-party providers in order to display personalized content. The responsibility for the use of your data beyond our processing lies with the third-party providers. Further information on the terms of use and legal processes for third-party providers can be found in the Privacy Policies for the respective provider in our Guidelines on the Use of Cookies.",
                        ],
                    },
                    {
                        type: "table",
                        value: [
                            ["Companies"],
                            ["HubSpot", "Cloudflare","Facebook","Google","Taboola", "Yahoo","LinkedIn","TUNE Inc.","FullStory Inc.","RTB House", "Twitter", "Spotify"],
                        ]
                    },
                ],
            },
        ],
        confirmSelection: "Submit preferences",
        selectAll: "Accept all",
        imprint: {
            label: "",
            href: "",
        }
    },
    en_GB: {
        alternativeDisplay: true,
        advancedPageFlow: true,
        heading: "Cookies and your options",
        mainDescription: [
            "We use cookies in order to provide you with the best possible user experience on our website and to provide you with relevant, targeted offers. Click on Accept all to consent to the use of all cookies. You can also choose which cookies you'll allow by checking the boxes below and clicking on Submit preferences to confirm your choices. You can change your preferences at any time in your <a href='[LINK_COOKIE_PAGE]'>settings</a>. More information on our use of cookies can be found in our <a href='[LINK_COOKIE_PAGE]'>Guidelines for the Use of Cookies</a> and our <a href='[LINK_PRIVACY_TERMS]'>Privacy Policy</a>."
        ],
        thirdCountryData: "Third countries are outside the European Union. With your consent, data is transferred to the USA, which has inadequate data protection. Authorities there may access data without a court order.",
        step1Description: [
            [
              "We use cookies to optimise our websites, improve our products, and show you interest-based ads with third parties. You can select and change your ",
              "CONFIG_BUTTON_TEXT",
              " anytime in the settings. More information can be found in our ",
              "LINK_COOKIE_PAGE",
              " and ",
              "LINK_PRIVACY_TERMS",
              ". Necessary cookies will be used even when you select ",
              "REJECT_BUTTON",
              "."
            ],
            [
                "By clicking \"",
                "SELECTALL_BUTTON",
                "\" you consent to data processing and transfer to third countries.","TOOLTIP"
            ]
          ],
        step2Description: [
          [
            "We use cookies to optimise our websites, improve our products, and show you interest-based ads with third parties. You can select and change your ",
              "CONFIG_BUTTON_TEXT",
              " anytime in the settings. More information can be found in our ",
              "LINK_COOKIE_PAGE",
              " and ",
              "LINK_PRIVACY_TERMS",
              ". Necessary cookies will be used even when you select ",
              "REJECT_BUTTON",
              "."
          ],
          [
            "By clicking \"",
            "SELECTALL_BUTTON",
            "\" you consent to data processing and transfer to third countries.","TOOLTIP"
          ]
        ],
        configButton: "Cookie settings",
        configButtonText: "cookie preferences",
        rejectButton: "Reject",
        privacyTermsLink: "privacy policy",
        cookiePageLink: "cookie policy",
        toggleLabel: "details",
        mainCategories: [
          {
              key: PrivacyConsentEnum.TECHNICAL,
              disabled: true,
              preSelected: true,
              label: "Required cookies",
              details: [
                  {
                      type: "text",
                      value: [
                          "These cookies are required in order to view and navigate our website, from selecting and adding a product to your shopping cart, through to the purchasing phase. Please note that basic functions like displaying and selecting products, adding items to your cart and signing into your account cannot be performed without them."
                      ],
                  },
              ],
          }, {
              key: PrivacyConsentEnum.STATISTICS,
              preSelected: false,
              label: "Analytics",
              details: [
                  {
                      type: "text",
                      value: [
                          "We use cookies for analytical purposes in order to better understand user behaviour and to support you in navigating throughout our product pages. This also allows us to track your movements to help us redesign and optimise our website to meet demands."
                      ],
                  },
              ],
          }, {
              key: PrivacyConsentEnum.MARKETING,
              label: "Marketing",
              details: [
                  {
                      type: "text",
                      value: [
                          "We store information on your user behavior on our website in order to provide customized offers and campaigns on, for example, the website itself or in follow-up marketing emails. These cookies also enhance your user experience on our website by reducing load times, and saving website content so that it does not have to be reloaded each time you visit. We are fully responsible for the processing and controlling of any data collected."
                      ],
                  },
              ],
          },
          {
              key: PrivacyConsentEnum.PARTNERSHIPS,
              label: "Partners",
              details: [
                  {
                      type: "text",
                      value: [
                          "If third-party cookies are enabled, data may be transmitted to third parties we partner with when you visit our website. In some cases, we use this data for our own purposes, such as customising products and offers to better meet your needs. In addition, the data may be read and used by third-party providers in order to display personalised content. The responsibility for the use of your data beyond our processing lies with the third-party providers. Further information on the purposes of use and legal processes for third-party providers can be found in the Privacy Policies for the respective provider in our Guidelines on the Use of Cookies.",
                      ],
                  },
                  {
                      type: "table",
                      value: [
                          ["Companies"],
                          ["Bing","Cloudflare","Facebook","FullStory Inc.","Google","HubSpot","LinkedIn","Outbrain","RTB House","Taboola","TUNE Inc.","Twitter","Yahoo", "Spotify"],
                      ]
                  },
              ],
          },
        ],
        confirmFunctional: "Reject",
        selectAllDefault: "Accept all",
        selectAllSelection: "Accept all",
        goBack: "back",
        confirmSelection: "Submit preferences",
        selectAll: "Accept all",
        imprint: {
            label: "",
            href: "",
        }
    },
    fr_FR: {
        advancedPageFlow: true,
        heading: "Informations sur les cookies",
        mainDescription: [
            "IONOS utilise des cookies pour vous offrir une expérience utilisateur de qualité, mesurer l'audience et vous proposer des offres personnalisées. Acceptez l'utilisation de tous les cookies ou choisissez parmi les options ci-dessous. Vous pouvez les modifier à tout moment dans vos <a href='[LINK_COOKIE_PAGE]'>paramètres</a>.Vous trouverez de plus amples informations sur l'utilisation des cookies dans notre <a href='[LINK_COOKIE_PAGE]'>Politique d'utilisation des cookies</a> et notre <a href='[LINK_PRIVACY_TERMS]'>Clause de confidentialité</a>."
        ],
        thirdCountryData: "Les pays tiers sont des pays extérieurs à l’Union européenne. En accordant votre consentement, les données seront transférées aux États-Unis, un pays tiers au niveau de protection insuffisant, où les autorités peuvent accéder à vos données sans décision judiciaire.",
        step1Description: [
          [
            "Nous utilisons des cookies afin de vous offrir une expérience utilisateur optimale, d’améliorer nos produits et de vous montrer des publicités personnalisées avec des fournisseurs tiers. Dans les ",
            "CONFIG_BUTTON",
            ", vous pouvez choisir les cookies que vous souhaitez autoriser et revenir sur vos choix à tout moment. Pour plus d'informations, veuillez consulter notre ",
            "LINK_COOKIE_PAGE",
            " et notre ",
            "LINK_PRIVACY_TERMS",
            ". Même si vous choisissez de les ",
            "REJECT_BUTTON",
            ", les cookies techniques indispensables seront installés."
          ],
          [
            "En cliquant sur ",
            "SELECTALL_BUTTON",
            ", vous consentez à cette utilisation des cookies et autorisez la transmission de vos données à des pays tiers.","TOOLTIP"
          ]
        ],
        step2Description: [
          [
            "Nous utilisons des cookies afin de vous offrir une expérience utilisateur optimale, d’améliorer nos produits et de vous montrer des publicités personnalisées avec des fournisseurs tiers. Vous pouvez choisir les cookies que vous souhaitez autoriser et revenir sur vos choix à tout moment. Pour plus d'informations, veuillez consulter notre ",
            "LINK_COOKIE_PAGE",
            " et notre ",
            "LINK_PRIVACY_TERMS",
            ". Même si vous choisissez de les ",
            "REJECT_BUTTON",
            ", les cookies techniques indispensables seront installés."
          ],
          [
            "En cliquant sur ",
            "SELECTALL_BUTTON",
            ", vous consentez à cette utilisation des cookies et autorisez la transmission de vos données à des pays tiers.","TOOLTIP"
          ]
        ],
        configButton: "Paramètres",
        rejectButton: "refuser",
        privacyTermsLink: "Clause de confidentialité",
        cookiePageLink: "Politique d'utilisation",
        toggleLabel: "infos",
        mainCategories: [
            {
                key: PrivacyConsentEnum.TECHNICAL,
                disabled: true,
                preSelected: true,
                label: "Cookies fonctionnels",
                details: [
                    {
                        type: "text",
                        value: [
                            "Ces cookies sont nécessaires d'un point de vue technique, afin de permettre la navigation sur notre site Internet. S’ils sont désactivés, les fonctions de base telles que l'affichage et la sélection des produits, l'ajout de produits dans le panier ou la connexion à votre compte ne sont pas possibles."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.STATISTICS,
                preSelected: false,
                label: "Cookies analytiques",
                details: [
                    {
                        type: "text",
                        value: [
                            "Nous utilisons des cookies à des fins statistiques, afin de mieux comprendre votre comportement en tant qu'utilisateur et de faciliter votre navigation sur nos pages. Nous utilisons également ces informations pour mieux adapter notre site Web à vos besoins."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.MARKETING,
                label: "Cookies publicitaires",
                details: [
                    {
                        type: "text",
                        value: [
                            "Nous stockons des informations sur la façon dont vous utilisez notre site afin de vous proposer des offres personnalisées dans le cadre de campagnes et d'activités de marketing direct, par exemple sur notre site Web lui-même ou à travers l'envoi d'emailings. Ces cookies améliorent également votre expérience utilisateur sur notre site en optimisant les temps de chargement : comme le contenu du site est sauvegardé, il ne doit pas être rechargé à chaque visite. Le traitement et le contrôle des données collectées est sous notre entière responsabilité."
                        ],
                    },
                ],
            },
            {
                key: PrivacyConsentEnum.PARTNERSHIPS,
                label: "Cookies tiers",
                details: [
                    {
                        type: "text",
                        value: [
                            "Si ces cookies sont activés, certaines données peuvent être transmises à des tiers lorsque vous visitez notre site. Dans certains cas, nous utilisons ces données à nos propres fins, par exemple pour personnaliser nos produits et nos offres afin de mieux répondre à vos besoins. Ces données peuvent également être lues et utilisées par des partenaires externes, afin d'afficher un contenu personnalisé. La responsabilité de l'utilisation de vos données par des partenaires externes leur incombe. Vous trouverez de plus amples informations dans notre Politique d'utilisation des cookies.",
                        ],
                    },
                    {
                        type: "table",
                        value: [
                            ["Entreprises"],
                            ["Bing","Cloudflare","Facebook","FullStory Inc.","Google","HubSpot","LinkedIn","Outbrain","RTB House","Taboola","TUNE Inc.","Twitter","Yahoo", "Spotify"],
                        ]
                    },
                ],
            },
        ],
        confirmSelection: "Enregistrer les paramètres",
        goBack: "Retour",
        selectAll: "Accepter",
        imprint: {
            label: "",
            href: "",
        }
    },
    es_ES: {
        alternativeDisplay: true,
        alternativeDisplaySpain: true,
        advancedPageFlow: true,
        heading: "Configuración de las cookies",
        mainDescription: [
            "En IONOS usamos las cookies para posibilitar la navegación, mejorar la usabilidad como usuario de nuestra página web, adaptándola a tus hábitos de navegación, obtener información con fines estadísticos, posibilitar la identificación de nuestros clientes en el acceso a nuestras herramientas y a la vez ofrecerte publicidad personalizada. A través de este Panel puedes seleccionar los tipos de cookies que aceptas, marcándolas y haciendo clic en Enviar preferencias. Estas pueden ser modificadas en cualquier momento a través de tu <a href='[LINK_COOKIE_PAGE]'>configuración</a>. Encontrarás más información sobre el <a href='[LINK_COOKIE_PAGE]'>uso de cookies</a> en nuestras <a href='[LINK_COOKIE_PAGE]'>Política de Cookies</a> y en nuestra <a href='[LINK_PRIVACY_TERMS]'>Política de privacidad</a>."
        ],
        thirdCountryData: "Los países terceros son países que no pertenecen a la Unión Europea. Con tu consentimiento, los datos se transfieren a Estados Unidos, un tercer país con un nivel de protección de datos insuficiente, y donde las autoridades podrían acceder a tus datos sin necesidad de una orden judicial.",
        step1Description: [
          [
            "En IONOS usamos las cookies para posibilitar la navegación, mejorar la usabilidad como usuario de nuestra página web, adaptándola a tus hábitos de navegación, obtener información con fines estadísticos, posibilitar la identificación de nuestros clientes en el acceso a nuestras herramientas y a la vez ofrecerte publicidad personalizada. A través de este Panel puedes seleccionar los tipos de cookies que aceptas, marcándolas y haciendo clic en Enviar preferencias. Estas pueden ser modificadas en cualquier momento a través de tu ", "CONFIG_BUTTON",". Encontrarás más información sobre el", "LINK_COOKIE_PAGE"," en nuestra ", "LINK_COOKIE_TERMS", " y en nuestra ","LINK_PRIVACY_TERMS","."
          ],
          [
            "Al hacer clic en \"",
            "SELECTALL_BUTTON",
            "\" aceptas todas las cookies, incluyendo las que conllevan la recogida y transmisión de tus datos a terceros países.","TOOLTIP"
          ]
        ],
        step2Description: [
          [
            "En IONOS usamos las cookies para posibilitar la navegación, mejorar la usabilidad como usuario de nuestra página web, adaptándola a tus hábitos de navegación, obtener información con fines estadísticos, posibilitar la identificación de nuestros clientes en el acceso a nuestras herramientas y a la vez ofrecerte publicidad personalizada. A través de este Panel puedes seleccionar los tipos de cookies que aceptas, marcándolas y haciendo clic en Enviar preferencias. Estas pueden ser modificadas en cualquier momento a través de tu ", "CONFIG_BUTTON",". Encontrarás más información sobre el", "LINK_COOKIE_PAGE"," en nuestra ","LINK_COOKIE_TERMS", " y en nuestra ","LINK_PRIVACY_TERMS","."
          ],
          [
            "Al hacer clic en \"",
            "SELECTALL_BUTTON",
            "\" aceptas todas las cookies, incluyendo las que conllevan la recogida y transmisión de tus datos a terceros países.","TOOLTIP"
          ]
        ],
        configButton: "Configurar",
        privacyTermsLink: "Política de privacidad",
        cookieTermsLink: "Política de Cookies",
        cookiePageLink: " uso de cookies",
        acceptDescription: [
            "Al hacer clic en \"",
            "SELECTALL_BUTTON",
            "\" aceptas todas las cookies, incluyendo las que conllevan la recogida y transmisión de tus datos a terceros países.","TOOLTIP"
        ],
        toggleLabel: "detalles",
        mainCategories: [
            {
                key: PrivacyConsentEnum.TECHNICAL,
                disabled: true,
                preSelected: true,
                label: "Requerido",
                details: [
                    {
                        type: "text",
                        value: [
                            "Las cookies requeridas técnicamente, permiten la navegación en nuestras páginas web. Estas aseguran que puedas ver nuestros sitios web y navegar en nuestras ofertas, desde la visualización hasta la selección en el carrito de compras. Las funciones básicas como la visualización y la selección de productos en nuestros sitios web, añadir al carrito de compras o el inicio de sesión no serían posibles sin ellas."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.STATISTICS,
                preSelected: false,
                label: "Estadísticas",
                details: [
                    {
                        type: "text",
                        value: [
                            "Utilizamos las cookies con fines estadísticos para comprender mejor tu comportamiento como usuario y para ayudarte en la navegación por nuestras páginas de ofertas. Esto también nos permite grabar tu navegación en nuestras páginas y utilizarla para el diseño orientado a la demanda de nuestros servicios."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.MARKETING,
                label: "Marketing",
                details: [
                    {
                        type: "text",
                        value: [
                            "Almacenamos la información sobre tu comportamiento como usuario en nuestra página web y utilizamos estos datos para generar ofertas y campañas individuales en el contexto de la comercialización directa y para ofrecer una mayor comodidad al utilizar nuestra página web. Estas cookies se utilizan, por ejemplo, para presentar ofertas especiales en la misma página web o en los correos. Además, con ellas logramos hacer que la navegación en nuestra página web sea lo más atractiva posible para ti. Las cookies establecidas para este propósito aceleran la carga y la navegación, ya que guardan el contenido del sitio web para que no tenga que ser recargado cada vez que se visita la página. La responsabilidad y el control del procesamiento de datos recae sobre nosotros."
                        ],
                    },
                ],
            },
            {
                key: PrivacyConsentEnum.PARTNERSHIPS,
                label: "Partners",
                details: [
                    {
                        type: "text",
                        value: [
                            "Los servicios de proveedores externos están integrados en nuestro sitio. Cuando visitas nuestra página, los datos se recogen mediante las cookies o tecnologías similares y se transmiten a terceros que son los responsables de la prestación de sus servicios. En algunos casos, IONOS utiliza estos datos para fines propios, en particular para poder mostrarte ofertas individuales de productos y servicios fuera de nuestro sitio web. Además, los datos pueden ser leídos y evaluados por los proveedores externos para, mostrarle un contenido personalizado. La responsabilidad del uso de sus datos va más allá de nuestro procesamiento y recae en los proveedores externos. ¿Hasta qué punto y con qué fines de base jurídica tiene lugar el tratamiento ulterior para los fines propios del tercero? Puedes encontrar toda la información referente a la protección de datos del terceros, que se encuentra en nuestra política sobre el uso de cookies.",
                        ],
                    },
                    {
                        type: "table",
                        value: [
                            ["Empresas"],
                            ["Bing","Cloudflare","Facebook","FullStory Inc.","Google","HubSpot","LinkedIn","Outbrain","RTB House","Taboola","TUNE Inc.","Twitter","Yahoo", "Spotify"],
                        ]
                    },
                ],
            },
        ],
        confirmSelection: "Enviar preferencias",
        confirmFunctional: "Rechazar Cookies",
        selectAll: "Aceptar Cookies",
        selectAllSelection: "Aceptar Cookies",
        goBack: "Volver",
        imprint: {
            label: "",
            href: "",
        }
    },
    it_IT: {
        alternativeDisplay: true,
        advancedPageFlow: true,
        heading: "Impostazioni dei cookie",
        mainDescription: [
            "Utilizziamo i cookie per offrirti la migliore esperienza utente possibile sul nostro sito web e per personalizzare gli annunci pubblicitari in base ai tuoi interessi. Fai clic su Accetta tutto per acconsentire all'uso di tutti i cookie. Puoi anche scegliere quali cookie consentire selezionando le caselle sottostanti e facendo clic su Invia preferenze per confermare le tue scelte. Puoi modificare le tue preferenze in qualsiasi momento nelle impostazioni. Ulteriori informazioni sul nostro utilizzo dei cookie sono disponibili nella nostra <a href='[LINK_COOKIE_PAGE]'>politica sui cookie</a> e nella nostra <a href='[LINK_PRIVACY_TERMS]'>politica sulla privacy</a>."
        ],
        thirdCountryData: "I paesi terzi sono paesi al di fuori dell'Unione Europea. Con il tuo consenso, i dati vengono trasferiti negli Stati Uniti, un paese terzo con un livello di protezione dei dati insufficiente, e in cui le autorità possono accedere ai tuoi dati senza un ordine del tribunale.",
        step1Description: [
          [
            "Utilizziamo i cookie per offrirti la migliore esperienza utente possibile sul nostro sito web e per personalizzare gli annunci pubblicitari in base ai tuoi interessi. Fai clic su ", "SELECTALL_BUTTON", " per acconsentire all'uso di tutti i cookie. Puoi anche scegliere quali cookie consentire selezionando le caselle sottostanti e facendo clic su Invia preferenze per confermare le tue scelte. Puoi modificare le tue preferenze in qualsiasi momento nelle ", "CONFIG_BUTTON", "."
          ],
          [
            "Ulteriori informazioni sul nostro utilizzo dei cookie sono disponibili nella nostra ", "LINK_COOKIE_TERMS", " e nella nostra ", "LINK_PRIVACY_TERMS", ". I cookie necessari verranno utilizzati anche se selezioni ", "REJECT_BUTTON", "."
          ],
          [
            "Cliccando su \"",
            "SELECTALL_BUTTON",
            "\", accetti la raccolta e la trasmissione dei tuoi dati a paesi terzi.","TOOLTIP"
          ]
        ],
        step2Description: [
          [
            "Utilizziamo i cookie per offrirti la migliore esperienza utente possibile sul nostro sito web e per personalizzare gli annunci pubblicitari in base ai tuoi interessi. Fai clic su ", "SELECTALL_BUTTON", " per acconsentire all'uso di tutti i cookie. Puoi anche scegliere quali cookie consentire selezionando le caselle sottostanti e facendo clic su Invia preferenze per confermare le tue scelte. Puoi modificare le tue preferenze in qualsiasi momento nelle ", "CONFIG_BUTTON", "."
          ],
          [
            "Ulteriori informazioni sul nostro utilizzo dei cookie sono disponibili nella nostra ", "LINK_COOKIE_TERMS", " e nella nostra ", "LINK_PRIVACY_TERMS", ". I cookie necessari verranno utilizzati anche se selezioni ", "REJECT_BUTTON", "."
          ],
          [
            "Cliccando su \"",
            "SELECTALL_BUTTON",
            "\", accetti la raccolta e la trasmissione dei tuoi dati a paesi terzi.","TOOLTIP"
          ]
        ],
        configButton: "impostazioni",
        privacyTermsLink: "politica sulla privacy",
        cookiePageLink: "impostazioni",
        configButtonText: "impostazioni",
        cookieTermsLink: "politica sui cookie",
        rejectButton: "Rifiuta",
        acceptDescription: [
            "Cliccando su \"",
            "SELECTALL_BUTTON",
            "\", accetti la raccolta e la trasmissione dei tuoi dati a paesi terzi.","TOOLTIP"
        ],
        toggleLabel: "dettagli",
        mainCategories: [
            {
                key: PrivacyConsentEnum.TECHNICAL,
                disabled: true,
                preSelected: true,
                label: "Cookie richiesti",
                details: [
                    {
                        type: "text",
                        value: [
                            "Questi cookie sono necessari per visualizzare e navigare sul nostro sito web, dalla selezione e aggiunta di un prodotto al carrello fino alla fase di acquisto. Si prega di notare che le funzioni di base come la visualizzazione e la selezione dei prodotti, l'aggiunta di articoli al carrello e l'accesso al proprio account non possono essere eseguite senza di essi."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.STATISTICS,
                preSelected: false,
                label: "Cookie analitici",
                details: [
                    {
                        type: "text",
                        value: [
                            "Utilizziamo i cookie a fini analitici per comprendere meglio il comportamento degli utenti e per supportarli nella navigazione tra le pagine dei nostri prodotti. Questo ci permette anche di tracciare i tuoi movimenti per aiutarci a riprogettare e ottimizzare il nostro sito web in base alle esigenze."
                        ],
                    },
                ],
            }, {
                key: PrivacyConsentEnum.MARKETING,
                label: "Marketing",
                details: [
                    {
                        type: "text",
                        value: [
                            "Memorizziamo informazioni sul tuo comportamento utente sul nostro sito web per offrirti offerte e campagne personalizzate, ad esempio sul sito stesso o nelle email di marketing di follow-up. Questi cookie migliorano inoltre la tua esperienza utente sul nostro sito web riducendo i tempi di caricamento e salvando i contenuti del sito in modo che non debbano essere ricaricati ogni volta che lo visiti. Siamo pienamente responsabili del trattamento e del controllo dei dati raccolti."
                        ],
                    },
                ],
            },
            {
                key: PrivacyConsentEnum.PARTNERSHIPS,
                label: "Cookie di terze parti",
                details: [
                    {
                        type: "text",
                        value: [
                            "Se i cookie di terze parti sono abilitati, i dati potrebbero essere trasmessi a terze parti con cui collaboriamo quando visiti il nostro sito web. In alcuni casi, utilizziamo questi dati per finalità interne, come la personalizzazione di prodotti e offerte per soddisfare al meglio le tue esigenze. Inoltre, i dati potrebbero essere letti e utilizzati da fornitori terzi al fine di visualizzare contenuti personalizzati. La responsabilità per l'utilizzo dei tuoi dati al di là del nostro trattamento spetta ai fornitori terzi. Ulteriori informazioni sulle finalità di utilizzo e sui procedimenti legali per i fornitori terzi sono disponibili nelle Informative sulla Privacy del rispettivo fornitore e nelle nostre Linee Guida sull'Uso dei Cookie.",
                        ],
                    },
                    {
                        type: "table",
                        value: [
                            ["Imprese"],
                            ["Bing","Cloudflare","Facebook","FullStory Inc.","Google","HubSpot","LinkedIn","RTB House","TUNE Inc.","Twitter","Yahoo"],
                        ]
                    },
                ],
            },
        ],
        confirmSelection: "Invia preferenza",
        confirmFunctional: "Rifiuta",
        selectAll: "Accetta tutto",
        selectAllSelection: "Accetta tutto",
        goBack: "Indietro",
        imprint: {
            label: "",
            href: "",
        }
    }
};

langConfig.en_CA = langConfig.en_US;
langConfig.es_MX = langConfig.es_ES;
